const ReviewsView = () =>
  // @ts-ignore
  import(/*webpackChunkName: "AboutUsView"*/ "@/views/sales/ReviewsView.vue");

export default {
  path: "reviews",
  name: "reviews",
  alias: ["comentarios"],
  component: ReviewsView,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
    isAmbiguous: true,
  },
};
